import Swiper from 'swiper/bundle';

if ($(".aktuelles-and-themen-slider.swiper-container").length > 0) {
    const aktuelles_and_themen_swiper = new Swiper(".aktuelles-and-themen-slider.swiper-container", {
        spaceBetween: 16,
        slidesPerView: 'auto',
        loop: false,
        navigation: {
            nextEl: ".swiper-button-next.aktuelles-and-themen-swiper-button",
            prevEl: ".swiper-button-prev.aktuelles-and-themen-swiper-button",
        },
        breakpoints: {
            320: {
                spaceBetween: 24,
            },
            768: {
                spaceBetween: 16,
            }
        }
    });
}